import React from "react";
import {BarChart, MapChart, SunburstChart} from "../chart";
import {Filters} from "./shared/Filters/Filters";
import {MapPoints} from "../chart/Map/MapPoints/MapPoints";
import {useFetchData} from "./shared/useFetchData";

const ZabytkiDashboard = () => {
    const [initData, data, filters, activeFilters, setFilters] = useFetchData('ZABYTKI', true);

    return (
        <div className="container">
            <div className="title-container">
                <h2 className={'title'}>Ewidencja zabytków</h2>
            </div>
            <Filters data={filters} setFilters={setFilters}/>
            <div className="visualization-container">
                <BarChart data={data} groupBy={'originalFunction'} value={'value'} title={'Funkcje'}/>
                <BarChart data={data} groupBy={'type'} value={'value'} title={'Typ'}/>
            </div>
            <div className="visualization-container">
                <MapChart data={initData}
                          filters={filters}
                          activeFilters={activeFilters}
                          groupBy={'organization'}
                          value={'value'}
                          featureClick={setFilters}/>
                <BarChart data={data}
                          groupBy={'organization'}
                          value={'value'}
                          layout={'horizontal'}
                          title={'Gmina'}/>
            </div>
            <div className="visualization-container">
                {/*<SunburstChart data={data} groupBy={'organization'} value={'value'} title={'Gmina'}/>*/}
                <BarChart data={data} groupBy={'protectionForm'} value={'value'} title={'Forma ochrony'}/>

                {/*<MapPoints data={data}*/}
                {/*           initialData={initData}*/}
                {/*           filters={filters}*/}
                {/*           activeFilters={activeFilters}*/}
                {/*           groupBy={'organization'}*/}
                {/*           value={'value'}*/}
                {/*           featureClick={setFilters}/>*/}
            </div>
        </div>
    )
}

export {ZabytkiDashboard as default}